import React from 'react';

const HeroBanner = () => {

  return (
    <div className="hero-banner">

      <div className="hero-overlay">

        <div className="hero-content">

          <h1>
            Unlimited Movies, TV Shows & Entertainment
          </h1>

          <p>
            Discover trending movies and explore cinematic worlds.
          </p>

        </div>

      </div>

    </div>
  );
};

export default HeroBanner;